module.exports = __webpack_public_path__ + "static/media/literature_survey.dd3825bd.png";